export const APP_NAME = "فارماکار";
export const PHARMA_TOK = "PHARMA_TOK";

export const IMAGE_URL_BASE="https://pharmakar.ir/";
export const MAIN_URL = "https://pharmakar.ir/api/";
